/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { MenuItem, TextField, TextFieldProps } from '@mui/material';

const CURRENCY_OPTIONS = ['USD', 'EUR', 'GBP'] as const;

type ReadOnlyCurrencySelectProps = Omit<TextFieldProps, 'select' | 'label'>;

// Commission currency follows the trip price currency and is never edited directly.
// pointer-events is off so the read-only select does not show a hover or open.
const ReadOnlyCurrencySelect = React.forwardRef<HTMLDivElement, ReadOnlyCurrencySelectProps>(
  ({
    InputProps,
    SelectProps,
    inputProps,
    sx,
    ...rest
  }, ref) => {
    const textFieldProps: TextFieldProps = {
      ...rest,
      fullWidth: true,
      label: 'Currency',
      select: true,
      InputProps: {
        readOnly: true,
        ...InputProps,
      },
      SelectProps: {
        readOnly: true,
        ...SelectProps,
      },
      inputProps: {
        tabIndex: -1,
        ...inputProps,
      },
      sx: [
        { pointerEvents: 'none' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ],
    };

    return (
      <TextField ref={ref} {...textFieldProps}>
        {CURRENCY_OPTIONS.map((code) => (
          <MenuItem key={code} value={code}>{code}</MenuItem>
        ))}
      </TextField>
    );
  },
);

ReadOnlyCurrencySelect.displayName = 'ReadOnlyCurrencySelect';

export default ReadOnlyCurrencySelect;
